import { ErrorBoundary } from "react-error-boundary";
import ErrorPage from "../components/error-page";
import MalnutritionAPIContextProvider from "../contexts/MalnutritionAPIContext/Provider";
import MalnutritionCardContent from "../components/malnutrition/malnutrition-card-content";
import { malnutritionUseMocks } from "../api/malnutrition/mocks";

import type { FC } from "react";

const MalnutritionPage: FC = () => {
  const urlParams = new URLSearchParams(window.location.search);
  // In mock mode the fixtures ignore the IDs, so fall back to placeholders that
  // keep the queries enabled. In real mode default to empty strings so the
  // queries stay disabled (no stray requests) until the embed is launched with
  // real emr_patient_id / emr_hospital_id params.
  const useMocks = malnutritionUseMocks();
  const emrPatientID =
    urlParams.get("emr_patient_id") ?? (useMocks ? "mock-patient" : "");
  const emrHospitalID =
    urlParams.get("emr_hospital_id") ?? (useMocks ? "mock-hospital" : "");

  return (
    <MalnutritionAPIContextProvider
      emrPatientID={emrPatientID}
      emrHospitalID={emrHospitalID}
    >
      <ErrorBoundary FallbackComponent={ErrorPage}>
        <MalnutritionCardContent />
      </ErrorBoundary>
    </MalnutritionAPIContextProvider>
  );
};

export default MalnutritionPage;
